import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { SITE_MAP_SECTIONS, SITE_URL } from '../data/siteMap';

const Sitemap = () => (
  <div className="flex min-h-screen w-full flex-col bg-gradient-to-br from-blue-50 to-teal-100">
    <Helmet>
      <title>Sitemap | PUREMEDIFY LIMITED</title>
      <meta
        name="description"
        content="Browse the full PureMedify website sitemap — pages, services, support options, and community resources."
      />
      <link rel="canonical" href={`${SITE_URL}/sitemap`} />
    </Helmet>

    <section className="relative flex w-full flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-blue-50 to-blue-100 py-16 md:py-24">
      <div className="relative z-10 mx-auto max-w-3xl px-4 text-center">
        <h1 className="mb-4 font-ubuntu text-4xl font-bold text-lochmara-blue drop-shadow-lg md:text-5xl">
          Site Map
        </h1>
        <p className="font-redhat text-lg text-gray-700 md:text-xl">
          A complete guide to every page and section on the PureMedify website.
        </p>
      </div>
      <svg className="absolute left-10 top-10 h-24 w-24 opacity-30" viewBox="0 0 100 100" fill="none">
        <circle cx="50" cy="50" r="40" fill="#0087ca" />
      </svg>
      <svg className="absolute bottom-10 right-10 h-20 w-20 opacity-20" viewBox="0 0 100 100" fill="none">
        <circle cx="50" cy="50" r="35" fill="#00b937" />
      </svg>
    </section>

    <section className="mx-auto w-full max-w-6xl px-4 py-12">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
        {SITE_MAP_SECTIONS.map((section) => (
          <article
            key={section.id}
            className="rounded-2xl border border-white/80 bg-white/70 p-6 shadow-lg backdrop-blur-sm md:p-8"
          >
            <h2 className="mb-2 font-ubuntu text-2xl font-bold text-lochmara-blue">{section.title}</h2>
            <p className="mb-6 font-redhat text-sm text-gray-600 md:text-base">{section.description}</p>
            <ul className="space-y-4">
              {section.links.map((link) => (
                <li key={`${section.id}-${link.label}`} className="border-b border-gray-100 pb-4 last:border-b-0 last:pb-0">
                  <Link
                    to={link.path}
                    className="group inline-flex items-center gap-2 font-ubuntu text-base font-semibold text-brand transition hover:text-brand-green"
                  >
                    {link.label}
                    <svg
                      className="h-4 w-4 transition group-hover:translate-x-0.5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                  <p className="mt-1 font-redhat text-sm text-gray-600">{link.description}</p>
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>

      <div className="mt-10 rounded-2xl bg-gradient-to-r from-lochmara-blue to-brand px-6 py-8 text-center text-white shadow-lg md:px-10">
        <h2 className="mb-2 font-ubuntu text-2xl font-bold">Need help finding something?</h2>
        <p className="mb-6 font-redhat text-white/90">
          Use our site assistant in the bottom-right corner or contact our team directly.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link
            to="/contact"
            className="rounded-full bg-white px-6 py-3 font-ubuntu font-semibold text-lochmara-blue transition hover:bg-blue-50"
          >
            Contact Us
          </Link>
          <Link
            to="/"
            className="rounded-full border border-white/60 px-6 py-3 font-ubuntu font-semibold text-white transition hover:bg-white/10"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </section>
  </div>
);

export default Sitemap;
